<template>
  <v-dialog v-model="dialog" max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on" :disabled="!canAuthorizeWithdraw">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-cash-lock-open</v-icon>
          </template>
          <span>{{ $t("authorizePayment") }}</span>
        </v-tooltip>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-form ref="form">
        <v-card-text class="my-3 text-center">
          <h3 class="pb-4">{{ message }}</h3>
          <div class="ml-4 pt-3 text-left">
            <div>{{ $t("withdrawalID") }}: {{ id_withdraw }}</div>
            <div class="pb-1">
              {{ $t("value") }}: {{ $t("labelCurrency")
              }}{{ entry | handleEntrys }}
            </div>
            <div class="pb-1">{{ $t("userID") }}: {{ user_id }}</div>
            <div class="pb-1">{{ $t("user") }}: {{ user_name }}</div>
            <!-- <div>Para: </div> -->
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="disabled"
            class="ma-1 info"
            small
            @click.prevent="authorizeCashout()"
            >{{ $t("toConfirm") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    "id_withdraw",
    "user_id",
    "user_name",
    "entry",
    "withdrawCanceled",
    "withdrawSuccess",
    "canAuthorizeWithdraw",
    "id_gateway",
  ],
  data: () => ({
    dialog: false,

    withdraw_id: "",
    disabled: false,
  }),
  computed: {
    message() {
      return this.$t("confirmWithdrawalAuthorization");
    },
    dialogTitle() {
      return this.$t("authorizeWithdrawal");
    },
  },
  methods: {
    authorizeCashout() {
      this.disabled = true;

      const map = {
        1: "/colab/bankOnline/authorizeCashout",
        2: "/colab/bankOnline/authorizeCashoutPayForFun",
        4: "/colab/bankOnline/authorizeWithdrawBrasilCash",
        8: "/colab/bankOnline/authorizeWithdrawPaybrokersV4",
        7: "/colab/payments/paag/authorizeWithdrawPaag",
        9: "/colab/payments/paguePay/authorizeWithdrawPaguePay",
        10: "/colab/payments/pagFast/authorizeWithdrawPagFast",
      };

      const endpoint = map[this.id_gateway];

      const body = {
        withdraw_id: this.id_withdraw,
      };
      this.$request
        .post(endpoint, body)
        .then((response) => {
          if (response.length == 0) return;
          this.$store.commit("setFeedbackSnack", {
            msg: response.messages,
            color: "success",
          });
          this.dialog = false;
          this.$emit("withdrawSuccess");
        })
        .catch((err) => {
          this.dialog = false;
          if (err.response.status == 403) {
            const data = {
              withdraw_id: this.id_withdraw,
              reason: err.response.data.dados.reason,
            };
            this.$emit("withdrawCanceled", data);
            this.$store.commit("setFeedbackSnack", {
              status: 403,
              msg: err.response.data.messages,
              color: "warning",
            });
          }
        })
        .finally(() => ((this.disabled = false), (this.dialog = false)));
    },
  },
  filters: {
    handleEntrys: function(value) {
      value = value * -1;
      return value;
    },
  },
};
</script>
